import { Check } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const takeaways = [
  "Business Model Canvas",
  "Roadmap 90 giorni",
  "Mappa IA",
  "AI Policy aziendale",
  "Pitch deck",
  "Una rete di colleghi con cui costruire",
];

export const Takeaways = () => (
  <section className="relative bg-white py-24 sm:py-32" data-testid="takeaways-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>Cosa porti a casa</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl font-black uppercase leading-[0.98] tracking-tight text-[#16256B] sm:text-5xl">
              Output concreti, non slide.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md font-body text-base leading-relaxed text-[#4A5268]">
              Alla fine dei 4 giorni non esci con appunti da archiviare, ma con
              strumenti operativi pronti a far muovere la tua impresa.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="divide-y divide-[#E4E8F2] border-y border-[#E4E8F2]">
            {takeaways.map((t, i) => (
              <Reveal
                key={t}
                delay={i * 0.08}
                className="group flex items-center justify-between py-6"
                data-testid={`takeaway-${i}`}
              >
                <div className="flex items-center gap-5">
                  <span className="font-display text-sm font-bold text-[#2D46A0]">
                    0{i + 1}
                  </span>
                  <span className="font-display text-2xl font-extrabold text-[#16256B] transition-colors duration-300 group-hover:text-[#C9A227] sm:text-3xl">
                    {t}
                  </span>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#16256B] text-white transition-colors duration-300 group-hover:bg-[#C9A227]">
                  <Check className="h-5 w-5" />
                </span>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
